import React from 'react';
import { PieChart, Pie, Cell, Tooltip, ResponsiveContainer, Legend } from 'recharts';



const PieAceiteTermo = ({data, title, colors}) => {



    return(<>
                <h4>{title}</h4>
            <ResponsiveContainer width="100%" height={200}>
              <PieChart>
                <Pie data={data} dataKey="value" nameKey="name" cx="50%" cy="50%" outerRadius={60} innerRadius={30} label>
                  <Cell fill={colors[0]} />
                  <Cell fill={colors[2]} />
                  <Cell fill={colors[1]} />
                  <Cell fill={colors[3]} />
                </Pie>
                <Tooltip />
                <Legend/>
              </PieChart>
            </ResponsiveContainer>
    
    </>)
}


export default PieAceiteTermo